export const lyric08 = `I said I hate you, I was angry
I got so mad, I slammed your door
You know I really love you, baby
I didn't mean to start a war
And I know there's a line, but I crossed it
And I pray that it won't leave a scar
I said I hate you, but I'm sorry
Sometimes I wish you'd cut me off
Maybe I should think before I talk
I get emotional and words come out all wrong
Sometimes I'm more honest than I want
So maybe I should think before, maybe next time I'll think before I talk
I try my best to make it better (better)
I'm all out of apologies (apologies)
You know I'm not good under pressure (pressure)
Guess hurting you is hurting me
I took all that we built and I broke it
And I pray it won't tear us apart
So let me piece it back together
I know I cut you pretty deep (know I cut you pretty deep)
Maybe I should think before I talk
I get emotional and words come out all wrong
Sometimes I'm more honest than I want
So maybe I should think before, maybe next time I'll think before
I know that I should think before I speak
'Cause I'm saying things that I don't even mean
Maybe I'm more honest than I wanna be
So maybe I should think before, maybe next time I'll think before I
Say something I might regret
And I might get too far under your skin
I can't lie, I wish we could try it again
Oh I, I wish we could try it again
Maybe I should think before I talk
I get emotional and words come out all wrong
Sometimes I'm more honest than I want
So maybe I should think before, maybe next time I'll think before
I know that I should think before I speak
'Cause I'm saying things that I don't even mean
Maybe I'm more honest than I wanna be
So maybe I should think before, maybe next time I'll think before I talk
Oh, oh, oh, oh
So maybe I should think before, maybe next time I'll think before I talk`